var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZilappLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8543 14.7044L14.6544 14.6966L19.9273 2.46844H7.08865C5.23991 2.46844 3.74121 3.96715 3.74121 5.81589C3.74121 7.66463 5.23992 9.16333 7.08866 9.16333H9.89954L4.05242 21.5316H16.8447C18.7098 21.5316 20.2296 20.0346 20.2579 18.1697C20.2867 16.2682 18.756 14.7097 16.8543 14.7044Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZilappLine);
export default __webpack_public_path__ + "static/media/zilapp_line.d925357cc99811959ce0ddcabcedf96a.svg";
export { ForwardRef as ReactComponent };